import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotBarChart = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M28.667 27.576c-1.298-3.596-6.133-3.907-10.157-3.693 2.661-1.669 2.052-6.905-1.843-6.883-2.444 0-4.844.662-6.96 1.921a14.116 14.116 0 0 0-5.09 5.25c-2.353 4.277-2.396 10.34 1.606 13.59 4.003 3.25 10.143 2.511 14.475.628 3.766-1.64 9.784-5.798 7.969-10.813Z"
            opacity={0.8}
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M6 35h28M8 21h4v10H8V21ZM18 6h4v25h-4V6Zm10 9h4v16h-4V15Z"
        />
    </SVG>
);
SpotBarChart.displayName = "SpotBarChart";
